var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4714)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4 33.75H23.6C19.21 33.75 17.25 31.79 17.25 27.4V22.6C17.25 18.21 19.21 16.25 23.6 16.25H28.4C32.79 16.25 34.75 18.21 34.75 22.6V27.4C34.75 31.79 32.79 33.75 28.4 33.75ZM23.6 17.75C20.02 17.75 18.75 19.02 18.75 22.6V27.4C18.75 30.98 20.02 32.25 23.6 32.25H28.4C31.98 32.25 33.25 30.98 33.25 27.4V22.6C33.25 19.02 31.98 17.75 28.4 17.75H23.6Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 30.75H24.5C21.6 30.75 20.25 29.4 20.25 26.5V23.5C20.25 20.6 21.6 19.25 24.5 19.25H27.5C30.4 19.25 31.75 20.6 31.75 23.5V26.5C31.75 29.4 30.4 30.75 27.5 30.75ZM24.5 20.75C22.42 20.75 21.75 21.42 21.75 23.5V26.5C21.75 28.58 22.42 29.25 24.5 29.25H27.5C29.58 29.25 30.25 28.58 30.25 26.5V23.5C30.25 21.42 29.58 20.75 27.5 20.75H24.5Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0098 17.75C21.5898 17.75 21.2598 17.41 21.2598 17V15C21.2598 14.59 21.5998 14.25 22.0098 14.25C22.4198 14.25 22.7598 14.59 22.7598 15V17C22.7598 17.41 22.4198 17.75 22.0098 17.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 17.75C25.59 17.75 25.25 17.41 25.25 17V15C25.25 14.59 25.59 14.25 26 14.25C26.41 14.25 26.75 14.59 26.75 15V17C26.75 17.41 26.41 17.75 26 17.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 17.75C29.59 17.75 29.25 17.41 29.25 17V15C29.25 14.59 29.59 14.25 30 14.25C30.41 14.25 30.75 14.59 30.75 15V17C30.75 17.41 30.41 17.75 30 17.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 21.75H34C33.59 21.75 33.25 21.41 33.25 21C33.25 20.59 33.59 20.25 34 20.25H36C36.41 20.25 36.75 20.59 36.75 21C36.75 21.41 36.42 21.75 36 21.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 25.75H34C33.59 25.75 33.25 25.41 33.25 25C33.25 24.59 33.59 24.25 34 24.25H36C36.41 24.25 36.75 24.59 36.75 25C36.75 25.41 36.42 25.75 36 25.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 29.75H34C33.59 29.75 33.25 29.41 33.25 29C33.25 28.59 33.59 28.25 34 28.25H36C36.41 28.25 36.75 28.59 36.75 29C36.75 29.41 36.42 29.75 36 29.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 35.75C29.59 35.75 29.25 35.41 29.25 35V33C29.25 32.59 29.59 32.25 30 32.25C30.41 32.25 30.75 32.59 30.75 33V35C30.75 35.41 30.41 35.75 30 35.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0098 35.75C25.5998 35.75 25.2598 35.41 25.2598 35V33C25.2598 32.59 25.5998 32.25 26.0098 32.25C26.4198 32.25 26.7598 32.59 26.7598 33V35C26.7598 35.41 26.4198 35.75 26.0098 35.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0098 35.75C21.5998 35.75 21.2598 35.41 21.2598 35V33C21.2598 32.59 21.5998 32.25 22.0098 32.25C22.4198 32.25 22.7598 32.59 22.7598 33V35C22.7598 35.41 22.4198 35.75 22.0098 35.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 21.75H16C15.59 21.75 15.25 21.42 15.25 21C15.25 20.58 15.59 20.25 16 20.25H18C18.41 20.25 18.75 20.59 18.75 21C18.75 21.41 18.42 21.75 18 21.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 25.75H16C15.59 25.75 15.25 25.41 15.25 25C15.25 24.59 15.59 24.25 16 24.25H18C18.41 24.25 18.75 24.59 18.75 25C18.75 25.41 18.42 25.75 18 25.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 29.75H16C15.59 29.75 15.25 29.41 15.25 29C15.25 28.59 15.59 28.25 16 28.25H18C18.41 28.25 18.75 28.59 18.75 29C18.75 29.41 18.42 29.75 18 29.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 28.05C25.8701 28.05 25.7401 28.02 25.6301 27.95C25.2701 27.74 25.1501 27.28 25.3501 26.93L26.0301 25.75H25.4401C24.9601 25.75 24.5701 25.54 24.3601 25.18C24.1501 24.82 24.1701 24.37 24.4001 23.96L25.3401 22.32C25.5501 21.96 26.0101 21.84 26.3601 22.04C26.7201 22.25 26.8401 22.71 26.6401 23.06L25.9601 24.24H26.5501C27.0301 24.24 27.4201 24.45 27.6301 24.81C27.8401 25.17 27.8201 25.62 27.5901 26.03L26.6501 27.67C26.5101 27.92 26.2601 28.05 26.0001 28.05Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4714",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4714",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.f6b00921217a121c216fed9e67974161.svg";
export { ForwardRef as ReactComponent };